import { tagCloud } from '../data';
import SectionHeader from './SectionHeader';

const sizeByWeight = (w: number) => {
  if (w >= 80) return 'text-lg md:text-xl font-bold text-primary-600';
  if (w >= 60) return 'text-base font-semibold text-foreground-800';
  if (w >= 45) return 'text-sm text-foreground-600';
  return 'text-xs text-foreground-500';
};

export default function TagCloud() {
  return (
    <section id="tags" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <SectionHeader
        kicker="Tag Cloud"
        title="话题标签云"
        desc="按标签快速筛出同一特征的话题。点击标签即可前往最新更新区查看对应内容。"
      />
      <div className="rounded-3xl border border-background-200/80 bg-background-100/60 p-6 md:p-8">
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-4">
          {tagCloud.map((t) => (
            <a
              key={t.label}
              href="#update"
              onClick={() => document.getElementById('update')?.scrollIntoView({ behavior: 'smooth' })}
              className={`whitespace-nowrap rounded-full px-1 py-1 font-medium transition hover:text-accent-600 hover:underline decoration-accent-300 underline-offset-4 ${sizeByWeight(
                t.weight,
              )}`}
            >
              #{t.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}